
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class PartySelectDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new PartySelectForm(this.idPrefix);
        public entity: any[];
        public option: string;
        public _checklist: ECommerce.OrderManagementCheckListRow[];
        constructor() {
            super();

            this.form = new PartySelectForm(this.idPrefix); 
        }

        protected getDialogTitle(): string {
            return "Select Supplier";
        }

        protected onDialogOpen() {
            super.onDialogOpen();
         
        }


        protected getDialogButtons(){
            return [
                {
                    text: 'Ok',
                    click: () => {
                        let now = new Date();
                        var voucherNo = "";
                        if (!this.validateBeforeSave())
                            return;
                        if (this.option == "Purchase Order") {

                            var purchaseorderdialog = new Common.OrderDialogForOrderProcessing();
                            voucherNo = FormatHelper.GetVoucherNo(53);
                            var OrderRow: Purchase.OrderRow = {
                                PartyId: parseInt(this.form.PartyId.value),
                                VoucherNo: voucherNo,
                                VoucherTypeId: 53,
                                CompanyId: Q.Authorization.userDefinition.CompanyId,
                                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                                UserId: Q.Authorization.userDefinition.UserId,
                                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                                TransDate: now.toDateString(),
                                ItemDetails: this.entity
                            };
                            this.dialogClose();
                            purchaseorderdialog.loadEntityAndOpenDialog(OrderRow, false);
                            return true;
                        } else if (this.option == "Work Order") {
                            var workorderdialog = new Inventory.StockAllocationDialog();
                            

                            voucherNo = FormatHelper.GetVoucherNo(53);
                            var StockAllocationRow: Inventory.StockAllocationRow = {
                                VoucherNo: voucherNo,
                                CompanyId: Q.Authorization.userDefinition.CompanyId,
                                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                                VoucherTypeId: 79,
                                TransDate: now.toDateString(),
                                EmployeeId: Q.Authorization.userDefinition.UserId,
                                ItemDetails: this.entity
                            };
                            this.dialogClose();
                            workorderdialog.loadEntityAndOpenDialog(StockAllocationRow, false);
                            return true;
                        }
                    },
                },
                {
                    text: 'Cancel',
                    click: () => {
                        //this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }
}